
      import {$emit} from 'uni-helpers/protocol/base/event-bus.js'
import {$off} from 'uni-helpers/protocol/base/event-bus.js'
import {$on} from 'uni-helpers/protocol/base/event-bus.js'
import {$once} from 'uni-helpers/protocol/base/event-bus.js'
import {canIUse} from 'uni-helpers/protocol/base/can-i-use.js'
import {chooseImage} from 'uni-helpers/protocol/media/choose-image.js'
import {createCanvasContext} from 'uni-helpers/protocol/context/context.js'
import {downloadFile} from 'uni-helpers/protocol/network/download-file.js'
import {getImageInfo} from 'uni-helpers/protocol/media/get-image-info.js'
import {getLocation} from 'uni-helpers/protocol/location/get-location.js'
import {getStorageSync} from 'uni-helpers/protocol/storage/storage.js'
import {makePhoneCall} from 'uni-helpers/protocol/device/make-phone-call.js'
import {navigateBack} from 'uni-helpers/protocol/route/route.js'
import {navigateTo} from 'uni-helpers/protocol/route/route.js'
import {pageScrollTo} from 'uni-helpers/protocol/ui/page-scroll-to.js'
import {preloadPage} from 'uni-helpers/protocol/route/route.js'
import {previewImage} from 'uni-helpers/protocol/media/preview-image.js'
import {reLaunch} from 'uni-helpers/protocol/route/route.js'
import {redirectTo} from 'uni-helpers/protocol/route/route.js'
import {removeStorageSync} from 'uni-helpers/protocol/storage/storage.js'
import {request} from 'uni-helpers/protocol/network/request.js'
import {setNavigationBarColor} from 'uni-helpers/protocol/ui/navigation-bar.js'
import {setNavigationBarTitle} from 'uni-helpers/protocol/ui/navigation-bar.js'
import {setStorageSync} from 'uni-helpers/protocol/storage/storage.js'
import {showLoading} from 'uni-helpers/protocol/ui/popup.js'
import {showModal} from 'uni-helpers/protocol/ui/popup.js'
import {showToast} from 'uni-helpers/protocol/ui/popup.js'
import {switchTab} from 'uni-helpers/protocol/route/route.js'
import {upx2px} from 'uni-helpers/protocol/base/upx2px.js'
      export default {
        $emit,
$off,
$on,
$once,
canIUse,
chooseImage,
createCanvasContext,
downloadFile,
getImageInfo,
getLocation,
getStorageSync,
makePhoneCall,
navigateBack,
navigateTo,
pageScrollTo,
preloadPage,
previewImage,
reLaunch,
redirectTo,
removeStorageSync,
request,
setNavigationBarColor,
setNavigationBarTitle,
setStorageSync,
showLoading,
showModal,
showToast,
switchTab,
upx2px
      }
      